export enum ValueLists {
  CompanyType = 'CompanyType',
  MarketActivity = 'MarketActivity',
  MembershipType = 'MembershipType',
  ProductCode = 'ProductCode',
  TitleInternal = 'TitleInternal'
}
